import { useState, useRef } from 'react';
import { FilterValue, CacheEntry } from '../types/index';
import Filters from '../Filters';

export const useGridState = (initialFilters?: FilterValue[]) => {
  const [rowData, setRowData] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [skip, setSkip] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [orderByParam, setOrderByParam] = useState<string | undefined>(undefined);
  const [order, setOrder] = useState<number | undefined>(undefined);
  const [showFiltersModal, setShowFiltersModal] = useState<boolean>(false);
  const [URLWithFilters, setURLWithFilters] = useState<string>('');
  const [showCopiedAlert, setShowCopiedAlert] = useState<boolean>(false);
  const [pendingFiltersToSave, setPendingFiltersToSave] = useState<FilterValue[] | null>(null);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [filtersLoadedFromURL, setFiltersLoadedFromURL] = useState<boolean>(false);
  const [incompleteFilterMessage, setIncompleteFilterMessage] = useState<string | null>(null);
  const [selectedRow, setSelectedRow] = useState<any[]>([]);
  const [isSessionExpired, setIsSessionExpired] = useState<boolean>(false);

  const [defaultFilterValue, setDefaultFilterValue] = useState<FilterValue[]>(() => {
    if (initialFilters) return initialFilters;
    return Filters.filter((f: any) => f).map((f: any) => ({ ...f, value: f.value || '' }));
  });

  const cacheRef = useRef<Record<string, CacheEntry>>({});
  const gridContainerRef = useRef<HTMLDivElement | null>(null);
  const prevDataRef = useRef<{ data: any[]; count: number }>({ data: [], count: 0 });
  const fetchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const prevTabRef = useRef<string>('');

  return {
    // State
    rowData,
    setRowData,
    totalCount,
    setTotalCount,
    loading,
    setLoading,
    showPopup,
    setShowPopup,
    skip,
    setSkip,
    limit,
    setLimit,
    orderByParam,
    setOrderByParam,
    order,
    setOrder,
    showFiltersModal,
    setShowFiltersModal,
    URLWithFilters,
    setURLWithFilters,
    showCopiedAlert,
    setShowCopiedAlert,
    pendingFiltersToSave,
    setPendingFiltersToSave,
    alertMessage,
    setAlertMessage,
    filtersLoadedFromURL,
    setFiltersLoadedFromURL,
    incompleteFilterMessage,
    setIncompleteFilterMessage,
    selectedRow,
    setSelectedRow,
    isSessionExpired,
    setIsSessionExpired,
    defaultFilterValue,
    setDefaultFilterValue,

    // Refs
    cacheRef,
    gridContainerRef,
    prevDataRef,
    fetchTimeoutRef,
    prevTabRef,
  };
};